import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import BurksContent from "./BurksPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/burks/pumps" component={BurksContent} />
          <Route path="/suppliers/burks">
            <Redirect to="/suppliers/burks/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
